<template>
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="list-articles container">
                <!-- Breadcrumb -->
                <div class="row">
                    <div class="col">
                        <ol class="breadcrumb">
                            <li>Cash Market</li>
                            <li>{{service.name}}</li>
                            <li class="active">{{category.name}}</li>
                        </ol>
                    </div>
                </div>

                <!-- Titulo de la sección -->
                <div class="row list-articles__title devices">
                    <div class="col-md-12 ">
                        <h1>{{ category.name }}</h1>
                    </div>
                </div> 

                <div class="row list-articles__container">
                    <!-- Side Menu ( Filtro de articulos ) -->
                    <div class="col-md-2">
                        <div class="row filter offer__cards-bg">
                            <!--  -->
                            <div class="filter__item brands">
                                <input type="search" name="search" placeholder="Buscar" v-model="search" class="form-control">
                            </div>
                            <div class="filter__item brands">
                                <select v-model="service_id" @change="refreshService" class="form-control">
                                    <option v-for="service in services" v-bind:value="service.id">
                                        {{ service.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="filter__item brands">
                                <select v-model="categories_id" @change="refresh" class="form-control">
                                    <option v-for="category in categories" v-bind:value="category.id">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>
                    
                    <!-- Lista de productos -->
                    <div class="col-md-10">
                        <div class="rovw">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-8">
                                        Mostrando 1 - {{ perPage * currentPage }} de {{ filteredList.length }} resultados para {{ category.name }}
                                    </div>
                                    <!--<div class="col-md-4">
                                        Ordenar por
                                    </div>-->
                                </div>

                                <div class="row offer__content">
                                    <div class="col-md-4  offer__cards offer__cards-bg" v-for="offer in filteredList">
                                        <a href="/#!/product-detail/{{offer.id}}"><img v-bind:src="this.urlApi+offer.images[0].path"></a>
                                        <h4>{{ offer.title }}</h4>
                                        <sub class="sign-price">RD$</sub> 
                                        <span class="currency-price">{{ offer.amount | currency}}</span> 
                                        <!--<sub class="cent-price">.00</sub>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            urlApi: "https://api.cashdepotint.com/",
            categories_id: 1,
            service_id: 1,
            category:{
                id: null,
                name: "General",
                service_type_id: null,
                created_at: null,
                updated_at: null,
                is_deleted: null,
            },
            service:{},
            services:[],
            search:"",
            offers:[],
            perPage: 20,
            currentPage: 1,
            categories:[]
        }
    },
    created() {
        this.categories_id = this.$route.params.id;
        this.service_id = this.$route.params.service_id;
        this.getCategory();
        this.getCategories();
        this.getService();
        this.getOffers();
        this.getServices();
    },
    computed: {
        filteredList() {
            return this.offers.filter(offer => {
                return offer.title.toLowerCase().includes(this.search.toLowerCase()) || offer.description.toLowerCase().includes(this.search.toLowerCase());
            })
        },
        rows() {
            return this.offers.length
        }
    },
    methods: {
        getCategory(){
            this.$http.get(apiUrl + '/categories/'+this.categories_id).then(response => {
                this.category = response.data;
            });
        },
        getCategories(){
            this.$http.get(apiUrl + `/categories&q=(service_type_id:${this.service_id})`).then(response => {
                this.categories = response.data;
            });
        },
        getService(){
            this.$http.get(apiUrl + '/service-types/'+this.service_id).then(response => {
                this.service = response.data;
            });
        },
        getServices(){
            this.$http.get(apiUrl + '/service-types').then(response => {
                this.services = response.data;
            });
        },
        getOffers(){
            this.loadingOffers = true;
            this.$http.get(apiUrl + `/offers?relationships=categories,offersProvider,typeDays,images&q=(is_deleted:0,categories_id:${this.categories_id},status_id:1)&limit=1000`).then(response => {
                this.offers = response.data;
                this.loadingOffers = false;
            });
        },
        refresh(){
            this.getCategory();
            this.getOffers();
        },
        refreshService(){
            this.getService();
            this.getCategories();
        }
    }
}
</script>

<style lang="css" scoped>
img {
    max-width: 100%;
}
h1 {
    font-size: 26px;
}
a {
    color:#213F99;
}
a:hover {
    text-decoration: underline;
    color:#213F99;
}
.offer__title h1 {
    font-weight: bold;
}
.offer__title a {
    display: block;
    margin: 30px 0px 20px;
    text-align: right;
}
.offer__title .col-lg-2,
.offer__title .col-lg-10 {
    padding-left:0px;
    padding-right:0px;
}
.offer__cards-bg {
    background: #fff;
    border: 1px solid #ccc;
    padding: 15px 20px;
}
.offer__cards {
    max-width: 292px;
    min-height: 450px;
    text-align: left;
    margin: 0 10px 20px;
}
.offer__cards h3 {
    margin-top: 20px;
}
.offer__cards p {
    font-size: 18px;
    margin-top: 30px;
    color:#42494B;
}
.offer__cards a {
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
}
.filter__item { /* remove */
    margin:15px 0;
}
.sign-price,
.currency-price {
    vertical-align: middle;
}
.currency-price {
    font-size: 30px;
}
.cent-price {
    vertical-align: sub;
}
</style>


// WEBPACK FOOTER //
// new-board.vue?489d57b2